import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const TableService = {
  shiftTable: async ({
    fromOrderMasterId,
    toTableId,
    fromSeatNo,
    toSeatNo,
    shiftedBy,
    fromTableTitle,
    toTableTitle,
    orderNo,
  }) => {
    try {
      // Prepare JSON payload with all values as strings
      const payload = {
        fromordermasterid: String(fromOrderMasterId),
        totableID: String(toTableId),
        fromSeatNo: String(fromSeatNo),
        toSeatNo: String(toSeatNo),
        shiftedby: String(shiftedBy),
        fromTableTitle: String(fromTableTitle),
        toTableTitle: String(toTableTitle),
        OrderNo: String(orderNo),
      };

      const response = await apiService.post(
        `/Modules/RestroDashboard/services/DashBoardWebService.asmx/shiftTable`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("Error in shiftTable:", error);
      throw error;
    }
  },

  shiftItem: async ({
    orderMasterId,
    orderNo,
    fromTable,
    fromTableTitle,
    toTable,
    toTableTitle,
    fromSplitNo,
    toSplitNo,
    shiftedBy,
    itemList, // array of items to shift
    shiftType = "Regular",
  }) => {
    try {
      // Build payload exactly like API expects
      const payload = {
        shiftItems: {
          shiftType,
          OrderMasterID: String(orderMasterId),
          OrderNo: String(orderNo),
          fromTable: String(fromTable),
          fromTableTitle,
          toTable: String(toTable),
          toTableTitle,
          fromSplitNo: String(fromSplitNo),
          toSplitNo: String(toSplitNo),
          shiftedBy,
          itemList,
        },
      };

      const response = await apiService.post(
        `/Services/RestroWebService.asmx/shiftItemsWeb`, // <- make sure endpoint is correct
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("Error in shiftItem:", error);
      throw error;
    }
  },

  // Define your API functions here
  getList: async () => {
    const response = await apiService.get("/tables");
    return response.data;
  },
  create: async (postData) => {
    const response = await apiService.post("/tables", postData);
    return response.data;
  },

  detail: async (id) => {
    const response = await apiService.get(`/tables/${id}`);
    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(`/tables/${id}`);
    return response.data;
  },
  update: async (id, updatedData) => {
    try {
      const response = await apiService.put(`/tables/${id}`, updatedData);
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },

  switchTable: async (orderId, newTableId) => {
    try {
      const response = await apiService.put(
        `/order/change-table?orderId=${orderId}&newTableId=${newTableId}`
      );
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },

  switchItem: async (newTableId, data) => {
    try {
      const response = await apiService.put(
        `/order/switch-item-table?newTableId=${newTableId}`,
        data
      );
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },

  getStatusCount: async () => {
    const response = await apiService.get("/tables/status-counts");
    return response.data;
  },
};

export default TableService;
